<div class="flex-row align-items-center">
  <ng-container *ngIf="analysts; else fetching">
    <mat-form-field class="full-width">
      <mat-label>{{ 'label.select_analyst' | translate }}</mat-label>
      <mat-select
        (selectionChange)="analystChange.emit($event.value)"
        [value]="analystSelected"
        [compareWith]="compareAnalysts"
      >
        <mat-select-trigger *ngIf="analystSelected">
          <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: analystSelected }"></ng-container>
        </mat-select-trigger>
        <mat-option *ngFor="let analyst of analysts" [value]="analyst">
          <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: analyst }"></ng-container>
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="!isCurrentUser && !editingEnabled">{{ 'hint.read_only_analysis' | translate }}</mat-hint>
    </mat-form-field>
    <button
      *ngIfRole="['analystmanager']"
      mat-icon-button
      class="bookmark-action"
      (click)="toogleReference.emit()"
      [disabled]="!isCurrentUser"
      [class.text-primary]="isCurrentUser"
      data-cy="button-mark-reference"
    >
      <ng-container *ngIf="!getStateFor(analystSelected?.id)?.reference; else removeReferenceTpl">
        <i
          class="ri-bookmark-3-line"
          #markTooltip="matTooltip"
          [matTooltip]="'tooltip.mark_reference_analysis' | translate"
          (mouseleave)="markTooltip.hide()"
        ></i>
      </ng-container>
      <ng-template #removeReferenceTpl>
        <i
          class="ri-bookmark-3-fill"
          #unmarkTooltip="matTooltip"
          [matTooltip]="'tooltip.unmark_reference_analysis' | translate"
          (mouseleave)="unmarkTooltip.hide()"
        ></i>
      </ng-template>
    </button>
  </ng-container>
  <ng-template #fetching> {{ 'info.fetching' | translate }}... </ng-template>
</div>

<ng-template #optionTpl let-analyst>
  <ng-container *ngIf="getStateFor(analyst.id) as analysisState">
    <div class="flex-row align-items-center justify-content-between">
      <span
        class="state-indicator"
        [matTooltip]="analysisState.state"
        [class.state-indicator--in-progress]="analysisState.state === 'inProgress'"
        [class.state-indicator--analyzed]="analysisState.state === 'analyzed'"
      >
      </span>
      <span
        class="analyst-name flex-grow-1 text-ellipsis"
        #nameTooltip="matTooltip"
        [matTooltip]="analyst.name"
        [matTooltipShowDelay]="1000"
        (mouseleave)="nameTooltip.hide()"
      >
        {{ analyst.name }}
      </span>
      <span class="text-gray align-self-end">
        <i
          *ngIf="analysisState.reference"
          class="ri-bookmark-3-fill text-primary"
          #refTooltip="matTooltip"
          [matTooltip]="'tooltip.marked_as_reference_analysis' | translate"
          (mouseleave)="refTooltip.hide()"
          data-cy="reference-analysis-mark"
        ></i>
        <small>{{ analysisState.updatedAt | date : 'dd/MM/yyyy, hh:mm a' }}</small>
      </span>
    </div>
  </ng-container>
</ng-template>
